import { PortalType } from '@studyportals/domain-client';
import { BaseSeoIndexabilityPolicy } from '../../common/policies/BaseSeoIndexabilityPolicy';
export class OrganisationsSeoIndexabilityPolicy extends BaseSeoIndexabilityPolicy {
    indexablePortalTypes = [PortalType.MASTER];
    constructor(dependencies) {
        super(dependencies);
    }
    async isIndexable() {
        const isIndexable = await super.isIndexable();
        if (!isIndexable) {
            return false;
        }
        return this.indexablePortalTypes.includes(this.dependencies.portalType) && this.matchesSortingOption();
    }
    matchesSortingOption() {
        const dependencies = this.dependencies;
        return dependencies.sortingState.getSelectedOption() === this.sortingOption;
    }
}
